import React, { useState } from 'react';
import { ChatModal } from '@/components/chat/ChatModal';
import T from "@/utils/i18n";
import { BotMessageSquare } from 'lucide-react';

export const GlobalChatPopup: React.FC = () => {
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);

  return (
    <>
      {/* Chat Button */}
      <button
        onClick={() => isChatModalOpen ? setIsChatModalOpen(false) : setIsChatModalOpen(true)}
        className="hidden sm:block fixed bottom-4 right-4 z-50 p-4 bg-gradient-to-br from-slate-600 via-blue-600 to-slate-600 text-white hover:bg-gradient-to-br hover:from-slate-800 hover:via-blue-800 hover:to-slate-800 rounded-full shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-300 ease-in-out transform hover:scale-105"
        aria-label="Open Chat"
      >
         {/*Chat Icon - Using a simple SVG for demonstration*/}
        {/*<svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">*/}
        {/*  <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />*/}
        {/*</svg>*/}
        <BotMessageSquare className="w-8 h-8" />
      </button>

      {/* Chat Modal */}
      {isChatModalOpen && (
        <ChatModal
          isOpen={isChatModalOpen}
          onClose={() => setIsChatModalOpen(false)}
          title={T.product.name["en"].concat(' Chat')}
        />
      )}
    </>
  );
};
